import { render, staticRenderFns } from "./atestado.vue?vue&type=template&id=6609dc88&scoped=true"
import script from "./atestado.vue?vue&type=script&lang=js"
export * from "./atestado.vue?vue&type=script&lang=js"
import style0 from "./atestado.vue?vue&type=style&index=0&id=6609dc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609dc88",
  null
  
)

export default component.exports